function substringAfter(str : string, separator : string)
{
    const indexOfFirst = str.indexOf(separator);

    return str.substring(indexOfFirst + separator.length)
}

function truncate(value : string | undefined, maxLength : number, postfix : string = "...") : string | undefined {
    return value !== null && value !== undefined && value.length > maxLength ? value.substring(0, maxLength) + postfix : value;
}

function isBlank(value : string | undefined) {
    return (value??"").trim().length === 0;
}

function isEmpty(value : string | undefined) {
    return (value??"").length === 0;
}

function escapeHtml(unsafe : string)
{
    if (unsafe === null || unsafe === undefined) {
        return "";
    }

    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function unquoteEmail(email : string | undefined)
{
    if (email === null || email === undefined) {
        return "";
    }

    return email.replace(/"(.*)"(.*)/, "$1 $2");
}

export const StringUtils = () => {
    return
}

StringUtils.substringAfter = substringAfter;
StringUtils.truncate = truncate;
StringUtils.isBlank = isBlank;
StringUtils.isEmpty = isEmpty;
StringUtils.escapeHtml = escapeHtml;
StringUtils.unquoteEmail = unquoteEmail;
